import { Controller } from '@hotwired/stimulus';
/* Componente que muestra u oculta un div según el radio button marcado.
 * Hay que hacer cosas raras porque el radio button no lanza el evento
 * change cuando se desmarca entonces tenemos que conectar en todos los
 * radios y al marcar uno, revisar el estado de todos para mostrar el que
 * se marque y ocultar los demás
 */
export default class extends Controller {
  connect() {
    this.radios = this.element.querySelectorAll('[type=radio]');
    this.#conectarEventos();
    // Revisamos al iniciar
    this.mostrarCapas();
  }

  #conectarEventos() {
    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        this.mostrarCapas();
      });
    });
  }

  mostrarCapas() {
    let targetSelected;
    this.radios.forEach((radio) => {
      const target = document.querySelector(radio.dataset.target);
      if (!target) {
        return;
      }

      // Esto lo hacemos para que varios radios puedan mostrar el mismo div
      if (target === targetSelected) {
        return;
      }
      if (radio.checked) {
        targetSelected = target;
      }

      target.style.display = radio.checked ? 'block' : 'none';
    });
  }
}
